<template>
  <div class="kpiOverview h100">
    <el-card>
      <el-form :inline="true" :model="bonusVersionList">
        <el-form-item label="年份">
          <!-- <el-date-picker v-model="bonusVersionList.year" type="year" value-format="yyyy" placeholder="请选择年份"></el-date-picker> -->
          <el-select v-model="bonusVersionList.year" @change="changeChange" placeholder="请选择年份">
            <el-option :label="item.label" :value="item.label" v-for="(item, index) in year" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="季度">
          <el-select v-model="bonusVersionList.quarter" @change="changeChange" placeholder="请选择季度">
            <el-option :label="item.label" :value="item.label" v-for="(item, index) in quarter" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道">
          <el-select v-model="bonusVersionList.channel" @change="changeChange" placeholder="请选择渠道">
            <el-option :label="item.label" :value="item.label" v-for="(item, index) in channel" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="职位">
          <el-select v-model="bonusVersionList.position" @change="changeChange" placeholder="请选择职位">
            <el-option :label="item.label" :value="item.label" v-for="(item, index) in position" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="search()" type="primary">搜 索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetSearch()" plain>清 空</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="downloadKpi()" type="primary">下 载</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="data" border :span-method="objectSpanMethod" header-cell-class-name="headerStyle" cell-class-name="cellStyle">
        <el-table-column v-for="(item, index) in columns" :key="index" :prop="item.prop" :label="item.label" :width="item.width">
        </el-table-column>
        <el-table-column label="权重" width="130">
          <template slot-scope="scope">
            <div>{{scope.row.kpiWeight}} %</div>
          </template>
        </el-table-column>
        <el-table-column label="KPI门槛" width="130">
          <template slot-scope="scope">
            <!-- <el-button type="primary" @click.native.prevent="QueryKpiRule(scope.row)">查看</el-button> -->
            <span v-if="scope.row.kpiAchCondition===null||scope.row.kpiAchCondition===''" class="operation">无</span>
            <span v-else class="operation" @click="QueryKpiRule(scope.row)">查看</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" v-if="roles.indexOf('Admin')>-1 || roles.indexOf('SFE')>-1">
          <template slot-scope="scope">
            <el-button type="primary" @click.native.prevent="editKpi(scope.$index,scope.row,data)">
              修改
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog class="kpiRule" title="KPI门槛" :visible.sync="visible" width="80%">
      <el-form :model="ruleData" ref="subKpiRuleRef" disabled>
        <div>
          <span class="conditionLabel">起奖设定</span>
          <el-form-item class="conditionSelect" prop='premiseConditionKpi'>
            <el-select v-model="ruleData.premiseConditionKpi" placeholder="Select">
              <el-option v-for="(v, i) in selectKpiList" :key="i" :label="v.label" :value="v.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="conditionSelect w100" prop='premiseConditionOperator'>
            <el-select v-model="ruleData.premiseConditionOperator" placeholder="Select">
              <el-option label=">" value=">"></el-option>
              <el-option label=">=" value=">="></el-option>
              <el-option label="<" value="<"></el-option>
              <el-option label="<=" value="<="></el-option>
              <el-option label="=" value="="></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="conditionInput" prop='premiseConditionValue'>
            <el-input v-model="ruleData.premiseConditionValue"></el-input>
          </el-form-item>
        </div>
        <div>
          <el-form-item class="conditionSelect w100" prop='connector0'>
            <el-select v-model="ruleData.connector0" placeholder="Select">
              <el-option label="AND" value="AND"></el-option>
              <el-option label="OR" value="OR"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="conditionSelect" prop='premiseConditionKpi1'>
            <el-select v-model="ruleData.premiseConditionKpi1" placeholder="Select">
              <el-option v-for="(v, i) in selectKpiList" :key="i" :label="v.label" :value="v.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="conditionSelect w100" prop='premiseConditionOperator1'>
            <el-select v-model="ruleData.premiseConditionOperator1" placeholder="Select">
              <el-option label=">" value=">"></el-option>
              <el-option label=">=" value=">="></el-option>
              <el-option label="<" value="<"></el-option>
              <el-option label="<=" value="<="></el-option>
              <el-option label="=" value="="></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="conditionInput" prop='premiseConditionValue1'>
            <el-input v-model="ruleData.premiseConditionValue1"></el-input>
          </el-form-item>
        </div>
        <el-divider></el-divider>
        <div label="" v-for="(item, index) in ruleData.conditions" :key="index">
          <span class="conditionLabel" v-if="index == 0">if</span>
          <el-form-item class="conditionSelect w100" v-if="index > 0" :prop='"conditions."+index+".connector"'>
            <el-select v-model="ruleData.conditions[index].connector" placeholder="Select">
            </el-select>
          </el-form-item>
          <el-form-item class="conditionSelect" :prop='"conditions."+index+".conditionKpi"'>
            <el-select v-model="ruleData.conditions[index].conditionKpi" placeholder="Select">
            </el-select>
          </el-form-item>
          <el-form-item class="conditionSelect w100" :prop='"conditions."+index+".conditionOperator"'>
            <el-select v-model="ruleData.conditions[index].conditionOperator" placeholder="Select">
            </el-select>
          </el-form-item>
          <el-form-item class="conditionInput" :prop='"conditions."+index+".conditionValue"'>
            <el-input v-model="ruleData.conditions[index].conditionValue"></el-input>
          </el-form-item>
        </div>
        <!-- <el-divider></el-divider> -->
        <el-form-item label="">
          <div class="conditionTitle">then</div>
          <el-form-item prop="thenValue2" label="">
            <span class="conditionLabel">系数 = </span>
            <el-radio-group v-model="ruleData.selectedThenValue">
              <el-radio label="1">
                <el-select v-model="ruleData.thenValue1" placeholder="Select">
                </el-select>
              </el-radio>
              <el-radio label="2">
                <el-input v-model="ruleData.thenValue2" placeholder="请输入系数"></el-input>
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form-item>
        <!-- <el-divider></el-divider> -->
        <el-form-item label="">
          <div class="conditionTitle">else</div>
          <el-form-item label="">
            <span class="conditionLabel">系数 = </span>
            <el-radio-group v-model="ruleData.selectedEndValue">
              <el-radio label="3">
                <el-select v-model="ruleData.endValue1" placeholder="Select">
                </el-select>
              </el-radio>
              <el-radio label="4">
                <el-input v-model="ruleData.endValue2" placeholder="请输入系数"></el-input>
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'kpiOverview',
  data () {
    return {
      // 用户信息
      userInfo: '',
      roles: [],
      bonusVersionList: {
        year: null,
        channel: null,
        position: null,
        quarter: null
      },
      year: [],
      channel: [],
      position: [],
      quarter: [],
      data: [], // KPI列表
      dataFilter: [], // 存储筛选项
      columns: [
        {
          prop: 'year',
          label: '年份',
          width: '130'
        },
        {
          prop: 'channel',
          label: '渠道',
          width: '130'
        },
        {
          prop: 'position',
          label: '职位',
          width: 'auto'
        },
        {
          prop: 'roleLevel',
          label: '职级',
          width: 'auto'
        },
        {
          prop: 'quarter',
          label: '季度',
          width: '130'
        },
        {
          prop: 'kpiType',
          label: 'KPI类型',
          width: '130'
        },
        {
          prop: 'kpi',
          label: 'KPI',
          width: 'auto'
        }
      ],
      // 门槛数据
      ruleData: {
        premiseConditionKpi: '',
        premiseConditionOperator: '',
        premiseConditionValue: '',
        connector0: '',
        premiseConditionKpi1: '',
        premiseConditionOperator1: '',
        premiseConditionValue1: '',
        conditions: [
          {
            connector: '',
            conditionKpi: '',
            conditionOperator: '',
            conditionValue: ''
          }
        ],
        selectedThenValue: '1',
        thenValueDisabled: 'false',
        thenValue1: '',
        thenValue2: '',
        selectedEndValue: '3',
        endValueDisabled: 'false',
        endValue1: '',
        endValue2: ''
      },
      visible: false,
      // 合并单元格
      yearArr: [],
      yearPos: '',
      channelArr: [],
      channelPos: '',
      positionArr: [],
      positionPos: '',
      roleLevelArr: [],
      roleLevelPos: '',
      quarterArr: [],
      quarterPos: '',
      kpiTypeArr: [],
      kpiTypePos: ''
    }
  },
  created () {
    this.getKpiList(this.bonusVersionList)
    // this.getKpiListAll(this.bonusVersionList)
  },
  mounted () {
    this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    // console.log(sessionStorage.getItem('userInfo'))
    // console.log(typeof (sessionStorage.getItem('userInfo')))
    let arr = this.userInfo.roles
    let roles = []
    if (arr != null && arr.length > 0) {
      arr.forEach(ele => {
        roles.push(ele.roleName)
      })
    }
    this.roles = roles
  },
  methods: {
    // 获取KPI配置列表
    getKpiList (data, message) {
      this.$http.post(this.API.kpiOverviewList, data).then((res) => {
        let data = res.data
        if (data.code === 200) {
          let arr = data.data
          arr.forEach(ele => {
            // 没有点（.）会直接取值
            ele.kpiWeight = ele.kpiWeight.split('.')[0]
          })
          arr.sort(this.mysort)
          // 处理筛选
          let year = []
          let channel = []
          let position = []
          let quarter = []
          arr.forEach(ele => {
            year.push({
              label: ele.year,
              value: ele.year
            })
            quarter.push({
              label: ele.quarter,
              value: ele.quarter
            })
            channel.push({
              label: ele.channel,
              value: ele.channel
            })
            position.push({
              label: ele.position,
              value: ele.position
            })
          })
          this.year = this.deWeightFour(year, 'label')
          this.channel = this.deWeightFour(channel, 'label')
          this.position = this.deWeightFour(position, 'label')
          this.quarter = this.deWeightFour(quarter, 'label')
          // 赋值
          this.data = arr
          // 全部值备用筛选
          this.dataFilter = arr
          // 合并单元格
          this.getSpanArr(this.data)
          // 处理筛选项
          if (message) {
            this.$message.success('搜索成功！')
          }
        } else {
          this.$message.error('接口调用失败！')
        }
      })
    },
    // 获取KPI配置列表--筛选项--去除不用
    getKpiListAll (data) {
      this.$http.post(this.API.kpiOverviewList, data).then((res) => {
        let data = res.data
        if (data.code === 200) {
          let arr = data.data
          arr.sort(this.mysort)
          this.dataFilter = arr
          let year = []
          let channel = []
          let position = []
          let quarter = []
          arr.forEach(ele => {
            year.push({
              label: ele.year,
              value: ele.year
            })
            quarter.push({
              label: ele.quarter,
              value: ele.quarter
            })
            channel.push({
              label: ele.channel,
              value: ele.channel
            })
            position.push({
              label: ele.position,
              value: ele.position
            })
          })
          year = this.deWeightFour(year, 'label')
          channel = this.deWeightFour(channel, 'label')
          position = this.deWeightFour(position, 'label')
          quarter = this.deWeightFour(quarter, 'label')
          this.year = year
          this.channel = channel
          this.position = position
          this.quarter = quarter
        } else {
          this.$message.error('接口调用失败！')
        }
      })
    },
    // 级联
    changeChange () {
      this.cascader()
    },
    // year channel position筛选KPI总览
    search () {
      // 去除null值
      let searchList = this.removePropertyOfNull(this.bonusVersionList)
      // 每次搜索重新赋值全部
      this.data = this.dataFilter
      // 多条件筛选
      this.data = this.multiFilter(this.dataFilter, searchList)
      // console.log(this.data)
      // 合并单元格
      this.getSpanArr(this.data)
      this.$message.success('搜索成功！')
    },
    // 重置
    resetSearch () {
      this.bonusVersionList = {
        year: null,
        channel: null,
        position: null,
        quarter: null
      }
      this.data = this.dataFilter
      // 合并单元格
      this.getSpanArr(this.data)
      this.cascader()
    },
    // 下载KPI
    downloadKpi () {
      this.$http.post(this.API.kpiOverviewExport, this.bonusVersionList, { responseType: 'blob' }).then(res => {
        // console.log(res)
        let blob = new Blob([res.data], { type: res.data.type })
        let downloadElement = document.createElement('a')
        let href = window.URL.createObjectURL(blob) // 创建下载的链接
        downloadElement.href = href
        downloadElement.download = 'KPI总览' + '.xls' // 下载后文件名
        document.body.appendChild(downloadElement) // 添加元素
        downloadElement.click() // 点击下载
        document.body.removeChild(downloadElement) // 下载完成移除元素
        window.URL.revokeObjectURL(href) // 释放掉blob对象
        this.$message.success('下载成功！')
      })
    },
    // 查看KPI门槛
    QueryKpiRule (row) {
      // console.log(row)
      this.visible = true
      this.ruleData = row.kpiAchCondition
    },
    // 修改KPI配置列表
    editKpi (i, v, a) {
      // i--index 0开始
      // console.log(i)
      // v--row
      // console.log(v)
      // a--全部数据
      // console.log(a)
      let editData = []
      // 筛选同一个 年/渠道/职位的数据
      editData = a.filter((ele) => {
        return (ele.year === v.year && ele.channel === v.channel && ele.position === v.position)
      })
      // console.log(editData)
      // 跳转KPI配置关系
      this.$router.push({
        name: 'configRelation',
        params: { editData: editData }
      })
    },
    getSpanArr (data) {
      this.yearArr = []
      this.yearPos = 0
      this.channelArr = []
      this.channelPos = 0
      this.positionArr = []
      this.positionPos = 0
      this.roleLevelArr = []
      this.roleLevelPos = 0
      this.quarterArr = []
      this.quarterPos = 0
      this.kpiTypeArr = []
      this.kpiTypePos = 0
      for (let i = 0; i < data.length; i++) {
        if (i === 0) {
          this.yearArr.push(1)
          this.yearPos = 0 // pos是spanArr的索引
          this.channelArr.push(1)
          this.channelPos = 0
          this.positionArr.push(1)
          this.positionPos = 0
          this.roleLevelArr.push(1)
          this.roleLevelPos = 0
          this.quarterArr.push(1)
          this.quarterPos = 0
          this.kpiTypeArr.push(1)
          this.kpiTypePos = 0
        } else {
          // 第一行
          // 判断当前元素与上一个元素是否相同
          if (data[i].year === data[i - 1].year) {
            // 相同的话 就加一 表示合并行数加一  0表示该行不显示
            this.yearArr[this.yearPos] += 1
            this.yearArr.push(0)
          } else {
            // 不相同就添加一位1 并设置索引位置
            this.yearArr.push(1)
            this.yearPos = i
          }
          // 第二行
          if (
            data[i].year === data[i - 1].year &&
            data[i].channel === data[i - 1].channel
          ) {
            this.channelArr[this.channelPos] += 1
            this.channelArr.push(0)
          } else {
            this.channelArr.push(1)
            this.channelPos = i
          }
          // 第三行
          if (
            data[i].year === data[i - 1].year &&
            data[i].channel === data[i - 1].channel &&
            data[i].position === data[i - 1].position
          ) {
            this.positionArr[this.positionPos] += 1
            this.positionArr.push(0)
          } else {
            this.positionArr.push(1)
            this.positionPos = i
          }
          // 第四行
          if (
            data[i].year === data[i - 1].year &&
            data[i].channel === data[i - 1].channel &&
            data[i].position === data[i - 1].position &&
            data[i].roleLevel === data[i - 1].roleLevel
          ) {
            this.roleLevelArr[this.roleLevelPos] += 1
            this.roleLevelArr.push(0)
          } else {
            this.roleLevelArr.push(1)
            this.roleLevelPos = i
          }
          // 第四行+
          if (
            data[i].year === data[i - 1].year &&
            data[i].channel === data[i - 1].channel &&
            data[i].position === data[i - 1].position &&
            data[i].roleLevel === data[i - 1].roleLevel &&
            data[i].quarter === data[i - 1].quarter
          ) {
            this.quarterArr[this.quarterPos] += 1
            this.quarterArr.push(0)
          } else {
            this.quarterArr.push(1)
            this.quarterPos = i
          }
          // 第五行+
          if (
            data[i].year === data[i - 1].year &&
            data[i].channel === data[i - 1].channel &&
            data[i].position === data[i - 1].position &&
            data[i].roleLevel === data[i - 1].roleLevel &&
            data[i].quarter === data[i - 1].quarter &&
            data[i].kpiType === data[i - 1].kpiType
          ) {
            this.kpiTypeArr[this.kpiTypePos] += 1
            this.kpiTypeArr.push(0)
          } else {
            this.kpiTypeArr.push(1)
            this.kpiTypePos = i
          }
        }
        // console.log('spanarr', this.spanArr)
      }
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 9) {
        const _row1 = this.positionArr[rowIndex]
        const _col1 = _row1 > 0 ? 1 : 0
        // console.log(`rowspan:${_row} colspan:${_col}`)
        // [0,0] 表示这一行不显示， [2,1]表示行的合并数
        return {
          rowspan: _row1,
          colspan: _col1
        }
      } else if (columnIndex === 1) {
        const _row2 = this.positionArr[rowIndex]
        const _col2 = _row2 > 0 ? 1 : 0
        return {
          rowspan: _row2,
          colspan: _col2
        }
      } else if (columnIndex === 2) {
        const _row3 = this.positionArr[rowIndex]
        const _col3 = _row3 > 0 ? 1 : 0
        return {
          rowspan: _row3,
          colspan: _col3
        }
      } else if (columnIndex === 3) {
        const _row4 = this.roleLevelArr[rowIndex]
        const _col4 = _row4 > 0 ? 1 : 0
        return {
          rowspan: _row4,
          colspan: _col4
        }
      } else if (columnIndex === 4) {
        const _row5 = this.quarterArr[rowIndex]
        const _col5 = _row5 > 0 ? 1 : 0
        return {
          rowspan: _row5,
          colspan: _col5
        }
      } else if (columnIndex === 5) {
        const _row6 = this.kpiTypeArr[rowIndex]
        const _col6 = _row6 > 0 ? 1 : 0
        return {
          rowspan: _row6,
          colspan: _col6
        }
      } else {
        return {
          rowspan: 1,
          colspan: 1
        }
      }
    },
    mysort (a, b) {
      if (a.year !== b.year) {
        return a.year < b.year ? -1 : 1
      } else if (a.channel !== b.channel) {
        return a.channel < b.channel ? -1 : 1
      } else if (a.position !== b.position) {
        return a.position < b.position ? -1 : 1
      } else if (a.roleLevel !== b.roleLevel) {
        return a.roleLevel < b.roleLevel ? -1 : 1
      } else if (a.quarter !== b.quarter) {
        return a.quarter < b.quarter ? -1 : 1
      } else if (a.kpiType !== b.kpiType) {
        return a.kpiType < b.kpiType ? 1 : -1
      } else if (a.kpi !== b.kpi) {
        return a.kpi < b.kpi ? 1 : -1
      } else {
        return a.kpiWeight - b.kpiWeight
      }
    },
    // 数组对象去重
    deWeightFour (arr, key) {
      let map = new Map()
      for (let item of arr) {
        if (!map.has(item[key])) {
          map.set(item[key], item)
        }
      }
      return [...map.values()]
    },
    // 去除对象null值
    removePropertyOfNull (obj) {
      Object.keys(obj).forEach(item => {
        if (!obj[item]) delete obj[item]
      })
      return obj
    },
    // 多值同时筛选
    multiFilter (arr, filters) {
      let filterKeys = Object.keys(filters)
      // console.log(filterKeys)
      return arr.filter(ele => {
        return filterKeys.every(key => {
          return ele[key] === filters[key]
        })
      })
    },
    // 级联
    cascader () {
      // 去除null值
      let searchList = this.removePropertyOfNull(this.bonusVersionList)
      // 多条件筛选
      let filter = this.multiFilter(this.dataFilter, searchList)
      let year = []
      let channel = []
      let position = []
      let quarter = []
      filter.forEach(ele => {
        year.push({
          label: ele.year,
          value: ele.year
        })
        quarter.push({
          label: ele.quarter,
          value: ele.quarter
        })
        channel.push({
          label: ele.channel,
          value: ele.channel
        })
        position.push({
          label: ele.position,
          value: ele.position
        })
      })
      this.year = this.deWeightFour(year, 'label')
      this.channel = this.deWeightFour(channel, 'label')
      this.position = this.deWeightFour(position, 'label')
      this.quarter = this.deWeightFour(quarter, 'label')
    }
  }
}
</script>

<style lang="less" scoped>
.kpiRule {
  .conditionTitle {
    width:120px;
    text-align:center;
    font-size:16px;
    margin-bottom:22px;
    }
  .conditionLabel {
    width:120px;
    display:inline-block;
    text-align:center;
    font-size:16px;
  }
  .conditionSelect {
    padding: 0 10px;
    display: inline-block;
  }
  .conditionSelect1 {
    display: inline-block;
  }
  .w100 {
    width: 100px;
  }
  .conditionInput {
    padding:0 20px 0 10px;
    width:200px;
    display: inline-block;
  }
}
</style>
